import { render, staticRenderFns } from "./ProcessoRevisado.vue?vue&type=template&id=22a1fea2&scoped=true"
import script from "./ProcessoRevisado.vue?vue&type=script&lang=js"
export * from "./ProcessoRevisado.vue?vue&type=script&lang=js"
import style0 from "./ProcessoRevisado.vue?vue&type=style&index=0&id=22a1fea2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a1fea2",
  null
  
)

export default component.exports